import { SET_PAGE_SETTINGS } from "../../constants/actionTypes";

const initialState = {};

const pageReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_PAGE_SETTINGS:
            if (action.payload) {
                return action.payload;
            }
            return null;
        default:
            return state;
    }
};

export default pageReducer;